<template>
  <div
    class="apply-add-wrap"
    id="applyAdd"
  >
    <van-form
      ref="form"
      label-align="right"
      validate-first
      :show-error-message="false"
    >
      <div class="cell">
        <van-field
          v-model.trim="formData.userName"
          user-name="userName"
          :maxlength="20"
          label="姓名："
          label-align="left"
          clearable
          placeholder="请填写姓名"
          label-width="103px"
          class="custom-field-font"
        >
          <template #button>
            <img
              v-if="userList.length >0"
              @click="contactClick"
              src="@/assets/img/icon-contact.png"
              class="contact-icon"
            >
          </template>
        </van-field>

        <van-cell>
          <div class="info-item">
            <div class="label-wrap">
              <div class="label">性别：</div>
            </div>
            <van-radio-group
              v-model="formData.sex"
              class="sex-content"
            >
              <van-radio
                name="M"
                checked-color="#FF6B22"
                icon-size="15px"
              >男</van-radio>
              <van-radio
                name="F"
                checked-color="#FF6B22"
                radio-size="30px"
                style="margin-left: 20px"
                icon-size="15px"
              >女</van-radio>
            </van-radio-group>
          </div>
        </van-cell>

        <van-field
          v-model.trim="formData.birthday"
          type="data"
          is-link
          readonly
          user-name="birthday"
          label="出生年月日："
          label-align="left"
          placeholder="请选择出生年月日"
          @click="selectBirthdayClick"
          label-width="103px"
          class="custom-field-font"
        />

        <van-field
          v-model.trim="formData.userPhone"
          user-name="userPhone"
          :maxlength="11"
          type="tel"
          label="联系电话："
          label-align="left"
          placeholder="请输入"
          clearable
          label-width="103px"
          class="custom-field-font"
        />
        <van-field
          v-model.trim="formData.pin"
          center
          clearable
          maxlength="6"
          type="digit"
          label-align="left"
          label="短信验证码："
          placeholder="请输入验证码"
          label-width="103px"
          class="custom-field-font"
        >
          <template #button>
            <div class="send-pin-cell">
              <div class="line" />
              <span
                class="send-btn"
                @click.stop="sendpinClick"
              >
                <span
                  class="unsent"
                  :class="{ 'count-down': pinDisable }"
                >{{
                  pinTitle
                }}</span>
              </span>
            </div>
          </template>
        </van-field>
      </div>
    </van-form>

    <!-- 日期选择器弹出层 -->
    <van-popup
      v-model.trim="showDatePicker"
      round
      position="bottom"
    >
      <van-datetime-picker
        type="date"
        :formatter="dateFormatter"
        :max-date="maxDate"
        :min-date="minDate"
        :value="defaultDate"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>
  </div>
</template>

  <script>
import { throttle } from 'lodash';
import { complement0 } from '@/utils/index';
import { debounce } from 'lodash';
import { Toast } from 'vant';
import {
  channelUserCreateDental,
  paicApplyUserPhonePinGet,
  channelGetHOpenId,
  channelUserGet,
  channelUserUpdateDentalc,
  channelListByUserId
} from '@/common/api.js';
import { MobileRegExp } from '@/common/regex.js';

function initFormData() {
  return {
    userName: '',
    userPhone: '',
    sex: '',
    birthday: '',
    pin: '',
    applyUserId: '',
    userId: ''
  };
}

export default {
  name: 'Tooth',
  data() {
    return {
      formData: {
        ...initFormData()
      },
      pinTitle: '发送验证码',
      pinDisable: false,
      showDatePicker: false,
      submitLoading: false,
      countDownSecond: 60,
      maxDate: new Date(),
      minDate: new Date('1970/1/1'),
      defaultDate: new Date(),
      channel: '',
      applyUserId: '',
      userList: []// 用户列表
    };
  },
  mounted() {
    this.getDefaultParameters();
    this.receiveMessage();
  },
  updated() {
    this.postMessage();
  },
  methods: {
    postMessage() {
      // 获取窗口宽度
      const width = document.documentElement.clientWidth;
      // 获取窗口高度
      const element = document.getElementById('applyAdd');
      const height = element.scrollHeight;
      const data = { data: { width: width, height: height }};
      // 单独用window.postMessage 接收不到
      window.parent.postMessage(data, '*');
      console.log('发送宽高消息', data);
    },
    getDefaultParameters() {
      this.formData = {
        ...initFormData()
      };
      const defaultData = this.$route.query.data;
      console.log('接收的参数:', this.$route.query);
      if (defaultData) {
        const data = JSON.parse(defaultData);
        this.formData.userName = data.userName || '';
        this.formData.userPhone = data.userPhone || '';
        this.formData.sex = data.sex || '';
        this.formData.birthday = data.birthday || '';
        if (this.formData.birthday) {
          this.defaultDate = new Date(this.formData.birthday);
        }
      }
      this.channel = this.$route.query.channel || '';
      this.code = this.$route.query.code || '';
      // this.code = 'b010894946871430a61746d9d7a918fd87a7549999e85066eef4efbd77a70648cf9f43226484b3129a44987eb3098ce63e6924f9cca61d1bc0adac37434553285a1a76cb2ddb676c60539423aafa3bd0';
      console.log(this.formData);
      if (!this.formData.userId) {
        this.getOpenId();
      }
    },
    receiveMessage() {
      window.addEventListener('message', e => {
        console.log('监听消息: ', e.data);
        if (e.data) {
          if (e.data.type === 'submit') {
            this.handleSubmit();
          }
          if (e.data.selectDate) {
            this.formData.birthday = e.data.selectDate;
          }
          if (e.data.id) {
            this.applyUserId = e.data.id || ''; // 他们前端传过来的，对应我们的applyUserId
            this.formData.applyUserId = this.applyUserId;
            this.getUserInfo();
          }
        }
      });
    },
    handleCancel() {
      const data = { data: 'cancel' };
      window.parent.postMessage(data, '*');
      console.log('发送取消消息：', data);
    },
    handleSubmit: throttle(async function() {
      try {
        const valid = this.checkSubmit();
        if (!valid) {
          return;
        }
        this.submitLoading = true;
        // this.$toast.loading({
        //   message: '提交中',
        //   forbidClick: true,
        //   duration: 0
        // });
        const params = {
          ...this.formData
        };
        const url = this.formData.applyUserId ? channelUserUpdateDentalc : channelUserCreateDental;
        const applyUserId = await url(params);
        if (applyUserId) {
          this.formData.applyUserId = applyUserId;
        }
        this.submitLoading = false;
        // this.$toast.clear();

        const data = { ...this.formData };
        data.data = 'confirm';
        data.success = true;
        if (data.pin) {
          delete data.pin;
        }
        // 给平安发送消息
        setTimeout(() => {
          // 给平安发送消息
          window.parent.postMessage(data, '*');
          console.log('发送成功消息：', data);
        }, 500);
      } catch (error) {
        this.submitLoading = false;
        if (error.length > 0) {
          const item = error[0];
          Toast(item.message);
        }
      }
    }, 2000),
    checkSubmit() {
      console.log(this.formData);
      if (!this.formData.userName) {
        Toast('姓名不能为空');
        return false;
      }
      const userNameReg = /^[\u4e00-\u9fa5]{1,20}$/;
      if (!userNameReg.test(this.formData.userName)) {
        Toast('姓名仅支持中文');
        return false;
      }
      if (!this.formData.sex) {
        Toast('性别不能为空');
        return false;
      }
      if (!this.formData.birthday) {
        Toast('出生年月日不能为空');
        return false;
      }
      if (!this.formData.userPhone) {
        Toast('联系电话不能为空');
        return false;
      }
      if (!MobileRegExp.test(this.formData.userPhone)) {
        Toast('请输入正确的联系电话码');
        return false;
      }
      if (!this.formData.pin) {
        Toast('验证码不能为空');
        return false;
      }
      return true;
    },
    async getOpenId() {
      try {
        const params = {
          code: this.code,
          productCategoryCode: 'FLH0000006'
        };
        const res = await channelGetHOpenId(params);
        this.formData.userId = res;

        this.getUserChannelList();
        console.log('响应', res);
      } catch (error) {
        console.log(error);
      }
    },
    async getUserInfo() {
      try {
        const params = {
          applyUserId: this.applyUserId
        };
        const res = await channelUserGet(params);
        if (res) {
          this.formData.userName = res.name || '';
          this.formData.userPhone = res.mobilePhone || '';
          this.formData.sex = res.sex || '';
          this.formData.userId = res.userId || '';
          this.formData.birthday = res.birthday || '';
          this.formData.applyUserId = res.applyUserId || '';
          this.applyUserId = res.applyUserId || '';
          if (this.formData.birthday) {
            this.defaultDate = new Date(this.formData.birthday);
          }
        }
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },
    async getUserChannelList() {
      try {
        const params = {
          userId: this.formData.userId
        };
        const res = await channelListByUserId(params);
        this.userList = res || [];
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    },
    onDateConfirm(date) {
      this.showDatePicker = false;
      const res =
        date.getFullYear() +
        '-' +
        complement0(date.getMonth() + 1) +
        '-' +
        complement0(date.getDate());
      this.formData.birthday = res;
    },
    dateFormatter(type, val) {
      switch (type) {
        case 'year':
          return val + '年';
        case 'month':
          return val + '月';
        case 'day':
          return val + '日';
        default:
          return val;
      }
    },
    countDown() {
      this.countDownSecond--;
      if (this.countDownSecond < 0) {
        clearInterval(this.timer);
        this.pinTitle = '获取验证码';
        this.pinDisable = false;
        return;
      }
      this.pinTitle = '获取验证码' + this.countDownSecond + 's';
    },
    sendpinClick: debounce(
      async function() {
        // 验证码不可点击
        if (this.pinDisable) {
          return;
        }
        if (!this.formData.userPhone) {
          Toast('联系电话不能为空');
          return;
        }
        if (
          this.formData.userPhone.length != 11 ||
          !MobileRegExp.test(this.formData.userPhone)
        ) {
          Toast('请输入正确的联系电话');
          return;
        }
        try {
          await paicApplyUserPhonePinGet({ phone: this.formData.userPhone });
          this.pinDisable = true;
          Toast('获取验证码成功');
          this.countDownSecond = 60;
          this.timer = setInterval(this.countDown, 1000);
        } catch (error) {
          console.log(error);
        }
      },
      2000,
      { leading: true, trailing: false }
    ),
    contactClick: debounce(
      function() {
        const data = { success: true, bookerList: this.userList };
        window.parent.postMessage(data, '*');
        console.log('发送成功消息：', data);
      },
      2000,
      { leading: true, trailing: false }
    ),
    selectBirthdayClick() {
      // this.showDatePicker = true;
      const data = { openDate: true, selectDate: this.formData.birthday };
      window.parent.postMessage(data, '*');
      console.log('发送日期弹框消息：', data);
    }
  }
};
  </script>

  <style lang="scss" scoped>
  .apply-add-wrap {
    background: #ffffff;
    border-radius: 10px 10px 0 0;
    font-size: 15px;
    // ::v-deep .van-cell--required {
    //   &:before {
    //     content: "";
    //   }
    //   .van-cell__title.van-field__label {
    //     color: #333333;
    //     span {
    //       position: relative;
    //       &:before {
    //         position: absolute;
    //         right: -8px;
    //         color: #ee0a24;
    //         font-size: 14px;
    //         content: "*";
    //       }
    //     }
    //   }
    // }

    ::v-deep .van-field__control::-webkit-input-placeholder {
      color: #cccccc;
      font-size: 14px;
      font-family: PingFangSC-Regular;
    }
    .cell {
      box-sizing: border-box;
      background: #fff;
      font-size: 30px;
      .img {
        width: 0.35rem;
      }
    }
    .send-pin-cell {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 15px;
      font-family: PingFangSC-Regular;
      .line {
        width: 1px;
        height: 22px;
        background: #e5e5e5;
      }
      .send-btn {
        font-size: 14px;
        text-align: right;
        padding-right: 0.3rem;
        padding-left: 0.24rem;
        .unsent {
          color: #222222;
        }
        .count-down {
          display: inline-block;
          color: #bcbfcc;
        }
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 100vw;
      flex: 1;
      height: 1.2rem;
      background: #fff;
      font-weight: 400;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      .btn {
        height: 0.9rem;
        border: 0px;
        border-radius: 22.5px;
        color: #ffffff;
        width: 3.15rem;
        background-image: linear-gradient(90deg, #ff6b22 0%, #ff8727 100%);
      }
      .btn-cancel {
        height: 0.9rem;
        border: 1px solid #e5e5e5;
        border-radius: 22.5px;
        color: #a5a5a5;
        background: #ffffff;
        width: 3.15rem;
      }
    }

    .contact-icon {
      // margin-left: 10px;
      width: 20px;
      height: 20px;
    }

    .info-item {
      display: flex;
      align-items: center;
      font-size: 15px;

      .label-wrap {
        width: 103px;

        display: flex;
        flex-direction: row;
        align-items: center;
        align-content: center;
        text-align: center;
        .label {
          text-align: left;
          color: #333333;
          position: relative;
          font-family: PingFangSC-Regular;
          // &:before {
          //   position: absolute;
          //   right: -8px;
          //   color: #ee0a24;
          //   font-size: 14px;
          //   content: "*";
          // }
        }
        .sex-tips {
          color: #ee0a24;
          font-size: 14px;
        }
      }

      .sex-content {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin-left: 12px;
        // margin-left: 1.32rem;
      }

      .sex-button {
        width: 0.96rem;
        height: 0.64rem;
        line-height: 0.64rem;
        text-align: center;
        border-radius: 0.1rem;
        font-size: 15px;
        font-weight: 400;
        background: #dde0e9;
        color: #808080;
      }

      .select {
        background: #3399ff;
        color: #ffffff;
      }
    }

    .tips {
      font-family: PingFangSC-Regular;
      font-size: 15px;
      color: #ff6300;
      text-align: center;
      font-weight: 400;
      text-align: center;
      margin-top: 11px;
      padding-bottom: 11px;
      line-height: 24px;
      background: white;
    }

    .custom-field-font {
      font-size: 15px;
      font-family: PingFangSC-Regular;
      color: #333333;
    }
  }
  </style>
